import { OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { DetailService } from '../services/detail.service';
var CardinfoComponent = /** @class */ (function () {
    function CardinfoComponent(detailService) {
        this.detailService = detailService;
        this.left = "left";
    }
    CardinfoComponent.prototype.createInfoCard = function () {
        var _this = this;
        this.detailService.createInfoCard(this.detailCardId, this.infoCardName).subscribe(function (result) {
            _this.componentId = result;
            _this.getInfoCard();
        });
    };
    CardinfoComponent.prototype.getInfoCard = function () {
        var _this = this;
        if (this.componentId) {
            this.detailService.getInfoCard(this.componentId).subscribe(function (result) {
                _this.infoCard = JSON.parse(result);
            });
        }
    };
    CardinfoComponent.prototype.ngOnInit = function () {
    };
    CardinfoComponent.prototype.ngOnChanges = function (changes) {
        if (this.componentId) {
            this.getInfoCard();
        }
        else {
            this.createInfoCard();
        }
    };
    return CardinfoComponent;
}());
export { CardinfoComponent };
